import React from "react";
import { Spinner } from "./styles";

const LoadingSpinner = () => {
	return <Spinner />;
};

export default LoadingSpinner;
